import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top whenever the pathname changes.
 * Skips scrolling when only the query string or hash changes
 * (e.g. ?lang= switches, in-page #anchors) — so language toggle
 * and "View gallery" anchors keep their natural behaviour.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's auto-restore on back/forward so it doesn't
    // race with our reset (it can fight us on slow renders).
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
